<template>
  <div>
      <div class="row">
         <div class="col-6 ">
            <label for="cbsituacaopesq">Por:</label>
            <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacaofat" @change="mtdresultadofaturamento()">
                <option value="0">Dt. emissão</option>
                <option value="1">Dt. Fatura</option>
            </select>
          </div>

      </div>    
      <div style="padding-top: 20px;" class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" style="padding-right: 0px;">
          <ul style="padding-left: 0px; margin-bottom: 0px; overflow:auto;">
            <li v-for="(item, indice) in lstresultadofaturamento" :key="indice" class="li-item-card-dash">
              <span v-if="parseInt(item.stpedido) === 0" class="badge badge-primary badge-pill">
                {{ item.qtdpedidos }} {{ item.situacao }}
              </span>

              <span v-else-if="parseInt(item.stpedido) === 1" class="badge badge-secondary badge-pill"
                style="background-color: #5A956A;">
                {{ item.qtdpedidos }} {{ item.situacao }}
              </span>

              <span v-else class="badge badge-danger badge-pill">
                {{ item.qtdpedidos }} {{ item.situacao }}
              </span>


              <span class="txt-item-card-dash" style="float: right;">
                {{ mtdformatavalordecimal(parseFloat(item.totalpedidos)) }}
              </span>
            </li>
            <li v-show="parseFloat(vtotalservicos) > 0" class="li-item-card-dash">
              <span class="badge badge-info badge-pill">
                SERVIÇOS
              </span>
              <span class="txt-item-card-dash" style="float: right;">
                {{ mtdformatavalordecimal(parseFloat(vtotalservicos)) }}
              </span>
            </li>
          </ul>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="row" style="margin-top: 8px;">
            <div class="col-md-12">
              <h5 style="float: right; color: #5a956a; margin-bottom: 0px;">R$ {{
                mtdformatavalordecimal(mediafaturamento) }}</h5>
            </div>

            <div class="col-md-12">
              <h5 style="font-size: 12px; float: right;">MÉDIA FATURADA P/ PEDIDO</h5>
              <br>

              <!-- - Exibição da margem de lucro geral-->
              <h5 style="font-size: 12px; float: right;">MARGEM DE LUCRO: <b>{{
                mtdformatavalordecimal(this.margemlucrogeral) }}%</b> </h5>
              <br>

              <i v-if="parseInt(qtdnotaspendentes) > 0"  style="font-size: 18px; cursor: pointer; margin-top: 12px; "
                title="Há notas fiscais pendentes"
                @click.prevent="$router.push({ name: 'cadnotasfiscais', params: { pendentes: 1 } })"
                @mouseover="showpopover = true" @mouseleave="hidepopover" class="fa fa-exclamation-circle notasalert">
              </i>


              <div v-show="showpopover" class="popover-container">
                <div class="popover-content">
                  Há notas fiscais pendentes que precisam ser resolvidas. Clique aqui para gerenciá-las.
                </div>
                <div class="popover-arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
export default {
  name: "BarChartCard",
  data : function name(params) {
    return {
        lstresultadofaturamento : [],
       
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false,  
        vtotalservicos          : 0,
        mediafaturamento        : 0,
        usuariologado           : this.$store.state.usuario,
        qtdnotaspendentes       : 0,

        psituacaofat            : 1,

        lstresumopedidos        : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmediafaturados(){
            let mediafat = 0;

            if(this.lstresumopedidos){
                mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
            }
            return mediafat;
        }, 
        mtdmargemlucrogeral() {
          var vself               = this;
      
          const ptotalaberto		  = vself.lstresumopedidos.totalaberto;
          const ptotalfaturado	  = vself.lstresumopedidos.totalfaturado;
          const ptotalcusto 		  = vself.lstresumopedidos.totalcusto;
                
          let totalgeral          = ptotalaberto + ptotalfaturado;

          let dif                 = (parseFloat(totalgeral) - parseFloat(ptotalcusto))

          vself.margemlucrogeral  = 0;
          vself.margemlucrogeral  = dif / totalgeral * 100;
          
        },
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'tpdatabuscar', valor : vself.psituacaofat},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {

              try {
                vself.lstresultadofaturamento = response.data.mediafaturamento;
                vself.lstresumopedidos        = response.data.resumopedidos;

              
                vself.qtdnotaspendentes       = parseInt(response.data.resultnotas)
                if(vself.lstresultadofaturamento.length > 0){
                    vself.mtdmargemlucrogeral();
                }
              
                if(parseInt(vself.qtdnotaspendentes)> 0){
                    vself.showpopover = true;
                    setTimeout(() => {
                        vself.showpopover = false;
                    }, 5000);
                }

                vself.mediafaturamento   = vself.mtdmediafaturados();
                
              } catch (error) {
                 console.log(error);
              }
              
           
              vself.$emit('handlerLoader', false);										
          }).catch(function (response) {
              vself.lstresultadofaturamento = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);	
          });                
      },
  },
  mounted(){
    this.mtdresultadofaturamento();
  },
  computed:{
            
  },
}
</script>
